/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-undef */
export default (approvedIndividualInvestment = [], action) => {
  switch (action.type) {
    case "GET_APPROVED_INDIVIDUAL":
      return action.payload;
    default:
      return approvedIndividualInvestment;
  }
};
